<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <mat-form-field class="flex__child--auto" *ngIf="feedadvices$ | async as feedadvices">
      <mat-label>{{ 'animal-group.feedadvices.feedadvice' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'animal-group.feedadvices.feedadvice' | translate }}"
        formControlName="feedadvice"
        data-test="feedadvices-item__feedadvice"
      >
        <mat-option *ngFor="let feedadvice of feedadvices" [value]="feedadvice">
          {{ feedadvice.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.feedadvice?.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.feedadvices.applicability' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="applicability"
        placeholder="{{ 'animal-group.feedadvices.applicability' | translate }}"
        data-test="feedadvices-item__applicability"
      />
      <span matTextSuffix>%</span>
      <mat-error *ngIf="formGroup.controls.applicability?.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
      <mat-error
        *ngIf="
          !!formGroup.controls.applicability.errors && formGroup.controls.applicability.errors?.max
        "
      >
        {{ 'animal-group.feedadvices.validation-max-applicability' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'animal-group.feedadvices.start-date' | translate }}</mat-label>
      <input
        formControlName="startDate"
        matInput
        [matDatepicker]="startDatePicker"
        placeholder="{{ 'animal-group.feedadvices.start-date' | translate }}"
        data-test="feedadvice-item__start-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #startDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.startDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'animal-group.feedadvices.end-date' | translate }}</mat-label>
      <input
        formControlName="endDate"
        matInput
        [matDatepicker]="endDatePicker"
        placeholder="{{ 'animal-group.feedadvices.end-date' | translate }}"
        data-test="feedadvice-item__end-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #endDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</agr-form-dialog>
